// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "3.72.2/styles/main.bundle.css";
	// return url for filenames based on template
	return "3.72.2/styles/" + "videojs" + ".chunk.css?" + "93c12ab9c4a2a8a96094" + "";
};